export const payslipInputStatuses = Object.freeze([
  'draft',
  'sent_to_calculation',
  'calculating',
  'calculated',
  'paid',
  'invalidating',
  'invalidated'
])

export default {}
